"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyGetConsumerV2ReceiptsReceiptUuidPDFQuery = exports.api = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const config_1 = require("config");
const utils_1 = require("utils");
const baseQuery = (0, react_1.fetchBaseQuery)({
    baseUrl: config_1.REACT_APP_API_URL,
    prepareHeaders: async (headers, { getState }) => {
        const hyperDxCookie = (0, utils_1.getCookie)('__rum_sid');
        const testAutomationCookie = (0, utils_1.getCookie)('TestAutomation');
        headers.set('Hyperdx-Session-Info', hyperDxCookie);
        headers.set('X-Client-Page', window.location.href);
        if (testAutomationCookie) {
            headers.set('TestAutomation', testAutomationCookie);
        }
        const state = getState();
        const receiptToken = state?.root?.creditPortal?.receipt?.token;
        receiptToken &&
            headers.set('Authorization', process.env.NODE_ENV === 'test' ? '' : receiptToken);
    },
});
const baseQueryWithCamelize = (0, utils_1.camelizeResponse)(baseQuery);
exports.api = (0, react_1.createApi)({
    reducerPath: 'consumerPortalApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: (build) => ({
        //this endpoint is manually added to add the application/pdf header, but uses the codegen types
        getConsumerV2ReceiptsReceiptUuidPDF: build.query({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}`,
                headers: {
                    accept: 'application/pdf',
                },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const pdfWindowUrl = URL.createObjectURL(blob);
                    return { pdfWindowUrl };
                },
            }),
        }),
    }),
    keepUnusedDataFor: 0,
});
exports.useLazyGetConsumerV2ReceiptsReceiptUuidPDFQuery = exports.api.useLazyGetConsumerV2ReceiptsReceiptUuidPDFQuery;
